// TODO: nuskin.newShop.Buyer
import {nuskin} from '@nuskin/ns-util';
import newAccount from './newAccount.js';
import AuthenticationService from './authenticationService.js';
import UserService from './userService.js';
import Buyer from './buyer.js';

/**
 *
 * BuyerCookieService
 *
 * @namespace BuyerCookieService
 */
newAccount.BuyerCookieService = function(){
    "use strict";

    let STORAGE_KEY = 'nuskin.shop';
    let BUYERFORM_KEY = 'buyerForm';
    let LTOVERIFY_KEY = 'lto.verify';

    // ---------------------------------------------
    //
    //        Define all public methods.
    //
    // ---------------------------------------------
    let publicMethods = {

        /**
         * @memberof BuyerCookieService
         * @example
         * var buyer = BuyerCookieService.getBuyer()
         * @returns {object}
         */
        getBuyer : function(){
            let buyer = null;
            let buyerData = getStoredBuyer();
            if (buyerData !== null){
                buyer = Buyer;
                buyer.init(buyerData);
            }
            else if (AuthenticationService.isLoggedIn()){
                let user = UserService.getUser();
                buyer = Buyer;
                buyer.init(user);
                this.setBuyer(buyer);
            }
            return buyer;
        },

        /**
         * @memberof BuyerCookieService
         * @example
         * var browserName = BuyerCookieService.setBuyer(buyer)
         * @param buyer
         */
        setBuyer : function(buyer){
            writeBuyerToStorage(buyer);
        },

        /**
         * @memberof BuyerCookieService
         * @example
         * var browserName = BuyerCookieService.resetBuyerCookie()
         */
        resetBuyerCookie : function(){
            writeBuyerToStorage(null);
            resetLTOBuyerForm();
        }
    };

    // ---------------------------------------------
    //
    //        Define all private methods.
    //
    // ---------------------------------------------
    function getStoredBuyer(){
        let buyer = null;
        if ($.cookie !== undefined){
            let cookieVal = $.cookie(STORAGE_KEY);
            if (cookieVal !== null && cookieVal !== undefined) {
                let shop = JSON.parse(cookieVal);
                if (shop !== null && shop !== undefined){
                    buyer = JSON.parse(cookieVal).buyer;
                }
            }
        }
        return buyer;
    }

    function writeBuyerToStorage(buyer){
        if ($.cookie !== undefined) {
            let options = buyer === null ? {path:'/', expires: -1} : {path: '/'};

            if (buyer !== null && (typeof(buyer.instance) !== 'undefined' &&
                (buyer.instance === newAccount.Buyer.instance || buyer.instance === newAccount.User.instance))) {
                $.cookie(STORAGE_KEY, JSON.stringify({buyer: buyer.toJSON()}), options);
            }
            else{
                $.cookie(STORAGE_KEY, JSON.stringify({buyer: buyer}), options);
            }
        }
    }

    //Clean up any lto storage items set to insure they don't bleed over to another user.
    function resetLTOBuyerForm() {
        if (typeof localStorage !== "undefined") {
            localStorage.removeItem(BUYERFORM_KEY);
            localStorage.removeItem(LTOVERIFY_KEY);
        }
    }

    return publicMethods;
}();

export default newAccount.BuyerCookieService;
